<template>
  <div id="app">
    <ErrorBoundary name="AppErrorBoundary">
      <div class="min-h-screen flex flex-col relative">
        <TheNavigation
          v-if="isLoggedIn"
          class="flex-shrink-0"
          :user="currentUser"
          @search="onSearch"
        />

        <router-view class="flex-grow flex-shrink-0" />

        <TheFooter class="flex-shrink-0" />
        <TheNotificationSystem />
      </div>
    </ErrorBoundary>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  ErrorBoundary,
  TheFooter,
  TheNotificationSystem
} from '@listen360/alexandria'
import TheNavigation from '@/components/TheNavigation'

export default {
  name: 'Sparta',
  components: {
    ErrorBoundary,
    TheFooter,
    TheNavigation,
    TheNotificationSystem
  },
  methods: {
    onSearch(query) {
      this.$router.push({
        name: 'search',
        query: {
          q: query
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      currentUser: 'user/current'
    })
  }
}
</script>
